module.exports = __webpack_public_path__ + "img/card.87eedb37.png";